module.exports = __webpack_public_path__ + "img/ditu.bd4f33e8.png";